import WhiteLabel from './whitelabel.ui';

export default WhiteLabel;
